export enum AdminAddProgramFormItemName {
  Name = "name",
  Description = "description",
  DropoutTimeInDays = "dropoutTimeInDays",
  MedicineOrHealthSupplement = "medicineOrHealthSupplement",
}
